import React from 'react';
import { Field } from 'formik';
import AppFormikInput from 'components/form/formik/input/input';
import useAdminsAdd from '../hooks/use-admins-add';
import DialogForm from 'components/dialog/dialog-form';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import InputPassword from 'components/input/input-password';
import { ELabelPos } from 'components/form/formik/types';
import LabelWrapper from 'components/label-wrapper';
import useAdminsPermissionRoleGet from '../hooks/use-admins-permission-role-get';

type TValues = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    repeatPassword: string;
    adminType: string;
    adminPermissionRoleId: string;
};

const DialogCrudAdminAdd: React.FC<TDialogWrapperComponent> = ({
    isDialogOpen,
    setIsDialogOpen,
    asyncStatesHandlers,
}) => {
    const [onAdminsAdd, { isLoading }] = useAdminsAdd(asyncStatesHandlers);
    const { data: permissions } = useAdminsPermissionRoleGet();
    const initValues: TValues = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        repeatPassword: '',
        adminType: 'maker',
        adminPermissionRoleId: Array.isArray(permissions)
            ? permissions[0]?.id
            : '',
    };

    return (
        <DialogForm<TValues>
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Add admin user'}
            onSubmit={async (values) => {
                await onAdminsAdd(values);
            }}
            isLoading={isLoading}
            initValues={initValues}
            validate={(values) => {
                let errors: Partial<TValues> = {};

                if (values.firstName.length === 0) {
                    errors.firstName = 'Required';
                }
                if (values.lastName.length === 0) {
                    errors.lastName = 'Required';
                }
                if (values.email.length === 0) {
                    errors.email = 'Required';
                }
                if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                        values.email,
                    )
                ) {
                    errors.email = 'Must be valid email';
                }
                if (values.password.length === 0) {
                    errors.password = 'Required';
                }
                if (values.password !== values.repeatPassword) {
                    errors.password = 'Password must match';
                    errors.repeatPassword = 'Password must match';
                }
                return errors;
            }}
        >
            <AppFormikInput name={'firstName'} placeholder={'First name'} />
            <AppFormikInput name={'lastName'} placeholder={'Last name'} />
            <AppFormikInput name={'email'} placeholder={'Email'} />
            <AppFormikInput
                component={InputPassword}
                name={'password'}
                placeholder={'Password'}
            />
            <AppFormikInput
                component={InputPassword}
                name={'repeatPassword'}
                placeholder={'Repeat password'}
            />
            <LabelWrapper
                label={'Admin Permission Role'}
                labelPos={ELabelPos.top}
            >
                <Field
                    as="select"
                    name="adminPermissionRoleId"
                    style={{
                        borderColor: 'lightgray',
                        borderRadius: '5px',
                        height: '30px',
                    }}
                >
                    {Array.isArray(permissions) &&
                        permissions.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.roleName}
                            </option>
                        ))}
                </Field>
            </LabelWrapper>
        </DialogForm>
    );
};

export default DialogCrudAdminAdd;
